import { createShorthandFactory } from '@flowio/react-helpers';
import PageTitle from '../components/PageTitle';
export default createShorthandFactory(PageTitle, function (value) {
  return {
    children: value
  };
});